export type CollectionKey = keyof CollectionsInputs;

export interface CollectionsInputs {
    teamwork: CollectionInputs;
    strategy: CollectionInputs;
    service: CollectionInputs;
    software: CollectionInputs;
}

export interface CollectionInputs {
    selected: boolean;
    plan: CollectionPlan;
}

export type CollectionPlan = "free" | "standard" | "premium" | "enterprise";
